export default "__VITE_ASSET__BnT2C2M6__"